import template from "./cost-form.html";

const CostFormComponent = {
  bindings: {
    resolve: "<",
    onCancel: "&",
    onSave: "&",
  },
  template: template,
  controller: class CostFormController {
    /* @ngInject */
    constructor($rootScope, $filter, Notification, Cost) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.Cost = Cost;
    }

    $onInit() {
      this.cost =
        this.resolve.cost instanceof this.Cost
          ? angular.copy(this.resolve.cost)
          : new this.Cost();
      this.saving = false;
      if (!this.cost.currency)
        this.setCurrency(this.$rootScope.organization.settings.currency);
    }

    setCurrency(oldCurrency, newCurrency) {
      this.cost.currency = newCurrency || oldCurrency;
    }

    async save() {
      if (!this.form.$valid) return;
      this.saving = true;
      this.duplicatedName = false;
      try {
        await this.cost.save();
        this.onSave({ $value: this.cost });
      } catch (e) {
        if (e.status === 400 && e.data.includes("Duplicated cost name")) {
          this.duplicatedName = true;
        }
      } finally {
        this.saving = false;
        this.$rootScope.$applyAsync();
      }
    }
  },
};

export default CostFormComponent;
